
import React, { useRef, useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import '../stylesheets/upload-dialog.css'
import { CustomButton } from '../../../components/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { updateWabaProfilePic } from '../../../reducers/waba-profile/waba-prifile-actions';
import Loader from '../../../components/Loader';

export default function FileSelect({ onCancel }) {
     const { loading } = useSelector(state => state.wabaProfile);
    const [image, setImage] = useState(null);
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const handleOnChange = (e) => {
        const file = e.target.files[0];
        const objectURL = URL.createObjectURL(file)
        file['objectURL'] = objectURL;
        setImage(file);
    }
    const handleFileUpload = (e) => {
      
        setImage(e.files[0]);
    }

    

    const itemTemplate = (file) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                </div>
                {/* <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={()=>setImage(null)} /> */}
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <button className="flex align-items-center flex-column upload-btn" onClick={() => inputRef.current.click()} >

                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <div className="my-5 flex align-items-center flex-column">
                    <span style={{ fontSize: '1em', color: 'var(--text-color-secondary)' }}>
                        Click to Upload or Drag and Drop
                    </span>
                    <span style={{ fontSize: '0.8em', color: 'var(--text-color-secondary)' }}>PNG, JPG, Gif up to 5MB</span>
                </div>

            </button>
        );
    };
    const handleOnSaveClick = () => {
        
        const formData = new FormData();
        formData.append('FILE',image, image?.name)
        dispatch(updateWabaProfilePic(formData))
        .unwrap()
        .then(()=>{
            onCancel()
        })
        .catch(err=>{
            console.log('err',err);
        })
    }
    
    return (
        <div>
            {loading && <Loader visible={loading} />}
            {
                (image ) ? <div>
                    {itemTemplate(image)}
                </div> : (
                    <>
                        <input ref={inputRef} type='file' accept='accept="image/*' hidden onChange={handleOnChange} />
                        <FileUpload accept="image/*" maxFileSize={1000000} emptyTemplate={emptyTemplate}
                            customUpload={true}
                            uploadHandler={handleFileUpload}
                            auto
                        />
                    </>

                )
            }

            <div className='mt-3 flex justify-content-end align-items-center gap-3'>
                <CustomButton varient='text' label={'Cancel'} onClick={onCancel} />
                <CustomButton varient='filled' label={'Upload'} disabled={!image} onClick={handleOnSaveClick} />
            </div>
        </div>
    )
}
